import z from "zod";
import { cbHttp } from "./http.service"
import { CronjobOverviewDomainsSchema } from "@/schemas/cronjob.schema";

export const getCronjobEntries = async (): Promise<z.infer<typeof CronjobOverviewDomainsSchema>[]> => {
    return cbHttp.get("/api/cronjob/cronjoboverviewentries");
}

export const getCronjobEntry = async (domainID: string): Promise<z.infer<typeof CronjobOverviewDomainsSchema>> => {
    return cbHttp.get("/api/cronjob/cronjoboverviewentry/" + domainID);
}

export const deleteCronjobEntry = async (data: FormData): Promise<boolean> => {
    return cbHttp.post("/api/cronjob/deletecronjob", data);
}

export const createCronjobEntry = async (data: FormData): Promise<boolean> => {
    return cbHttp.post("/api/cronjob/createjob", data);
}